(function() {
  function removeModalTriggers() {
    // 找到所有有 data-bs-toggle="modal" 的产品图片 <li>
    document.querySelectorAll('.gallery-wrapper [data-bs-toggle="modal"]').forEach(el => {
      el.removeAttribute('data-bs-toggle');
      el.removeAttribute('data-bs-target');
      el.classList.remove('cursor-pointer');
    });
    
    // 同时找 .js-product-gallery 里的
    document.querySelectorAll('.js-product-gallery [data-bs-toggle="modal"]').forEach(el => {
      el.removeAttribute('data-bs-toggle');
      el.removeAttribute('data-bs-target');
      el.classList.remove('cursor-pointer');
    });
  }
  
  function init() {
    removeModalTriggers();
    
    // 保险：监听 DOM 变化，画廊重新渲染时再移除一次
    const galleryEl = document.querySelector('.gallery-wrapper');
    if (galleryEl) {
      const observer = new MutationObserver(removeModalTriggers);
      observer.observe(galleryEl, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-bs-toggle']
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();